import GATSBY_COMPILED_MDX from "/Users/sasha/Projects/samexpert-com/content/posts/about/index.mdx";
import React from 'react';
import {MDXProvider} from '@mdx-js/react';
import {Layout, SEO} from '@/blocks/layout';
import {getSeoImageNameFromStatic} from '@/utils/getSeoImageNameFromStatic';
const ServiceNewTemplate = ({pageContext, children}) => {
  return React.createElement(Layout, {
    breadcrumbsLink: pageContext.frontmatter.breadcrumbsLink ?? '/',
    breadcrumbsText: pageContext.frontmatter.breadcrumbsText ?? 'home',
    hasNoVerticalMargins: true,
    customPaddingTablet: pageContext.pagetype === 'about' && 64
  }, React.createElement(MDXProvider, null, children));
};
ServiceNewTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(ServiceNewTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = ({pageContext}) => {
  const {title, description, slug} = pageContext;
  return React.createElement(SEO, {
    title: title,
    description: description,
    image: getSeoImageNameFromStatic(slug)
  });
};
